import React from 'react';

import {Heading, Skeleton} from '@albert-io/atomic';

import {SkeletonRow} from 'client/TeacherDashboard/components/ListRowsSkeleton';

export const SkillPathsViewSkeleton = () => (
  <div aria-busy='true' className='gap-x3 pt-x4 flex flex-col'>
    <span className='sr-only' role='status'>
      Loading skill paths…
    </span>
    <Heading as='h2' className='m-x0' size='s'>
      Skill Paths
    </Heading>
    <div aria-hidden='true' className='gap-x2 flex flex-wrap items-center justify-between'>
      <Skeleton className='h-[44px] w-[340px] max-w-full rounded-full' />
      <div className='gap-x1 flex items-center'>
        <Skeleton className='w-x10 rounded-x1 h-[44px]' />
        <Skeleton className='w-x8 rounded-x1 h-[44px]' />
        <Skeleton className='rounded-x1 h-[44px] w-[44px]' />
      </div>
    </div>
    <div aria-hidden='true' className='flex flex-col'>
      {['r1', 'r2', 'r3', 'r4', 'r5', 'r6'].map((key) => (
        <SkeletonRow key={key} />
      ))}
    </div>
  </div>
);
